export const INITIALIZE_USER = 'INITIALIZE_USER';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
export const LOGOUT = 'LOGOUT';
export const SET_PHONE_LANGUAGE = 'SET_PHONE_LANGUAGE';